import { Box, Flex } from '@chakra-ui/react';

import SkeletonComponent from 'UiKit/skeleton';
import { Iteration } from 'Component/others';

import styles from './styles.module.css';

const SkeletonCard = () => {
  return (
    <Box className={styles['card-stock-host__skeleton']}>
      <Flex width="100%" gap="4px" direction="column">
        <SkeletonComponent height="21px" width="100%" mb="2px" />
        <SkeletonComponent height="21px" width="40%" mb="2px" />
      </Flex>
      <SkeletonComponent height="35px" width="20%" mb="2px" />
    </Box>
  );
};

const CardStockSkeleton = () => {
  return (
    <Box className={styles['card-stock-host__skeleton--container']} data-testid="card-stock__skeleton">
      <Iteration items={Array.from({ length: 6 })} render={() => <SkeletonCard />} />
    </Box>
  );
};

export default CardStockSkeleton;
